import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { provideHttpClient, withInterceptors, withXhr } from "@angular/common/http";
import { RouterModule } from "@angular/router";

// ECharts
import { NgxEchartsModule } from "ngx-echarts";

// Angular Material (shell navigation only)
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDividerModule } from "@angular/material/divider";
import { provideNativeDateAdapter } from "@angular/material/core";

import { AppComponent } from "./app.component";
import { NavigationComponent } from "./components/navigation/navigation.component";
import { AUTH_SESSION_INITIALIZER } from "./auth-session.initializer";
import { authInterceptor } from "./interceptors/auth.interceptor";
import { auditCorrelationInterceptor } from "./interceptors/audit-correlation.interceptor";
import { auditHttpErrorInterceptor } from "./interceptors/audit-http-error.interceptor";
import { AppRoutingModule } from "./app-routing.module";

@NgModule({
  declarations: [AppComponent, NavigationComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    AppRoutingModule,

    NgxEchartsModule.forRoot({
      echarts: () => import("echarts"),
    }),

    MatToolbarModule,
    MatSidenavModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatMenuModule,
    MatTooltipModule,
    MatDividerModule,
  ],
  providers: [
    provideNativeDateAdapter(),
    AUTH_SESSION_INITIALIZER,
    provideHttpClient(withXhr(), 
      withInterceptors([
        auditCorrelationInterceptor,
        auditHttpErrorInterceptor,
        authInterceptor,
      ]),
    ),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
